// 費用項目がどのモールで発生するかの定義。
// PL(plCalculation)と商品PL(productKpiColumns)でキー名が一部異なるため、両方を登録する。
//   - 単一モール : そのモールでしか発生しない項目（例: FBA費用は Amazon のみ）
//   - 複数モール : 複数のモールで発生する項目。該当モールのバッジを全て並べる
//     （例: 決済手数料は楽天と Yahoo の両方で発生する）
//   - 未登録     : 全モール共通の項目。バッジは付けない
//
// 値は文字列（単一）でも配列（複数）でも書ける。getFeeMalls が常に配列で返す。

// title は「このモールで発生する費用」の意。複数バッジが並ぶ項目があるため
// 「◯◯専用」とは書かない（決済手数料は楽天とYahooの両方で発生する）。
const malls = {
  amazon: { label: 'A', title: 'Amazonで発生', className: 'bg-warning text-dark' },
  rakuten: { label: '楽', title: '楽天で発生', className: 'bg-danger' },
  shopify: { label: 'S', title: 'Shopifyで発生', className: 'bg-success' },
  yahoo: { label: 'Y', title: 'Yahoo!ショッピングで発生', className: 'bg-primary' },
};

// 費用項目キー => モール
const feeMallByKey = {
  // --- PL(plCalculation) のキー ---
  commission: 'amazon',                 // 販売手数料
  fbaPerUnitFulfillmentFee: 'amazon',   // FBA費用
  inventoryFee: 'amazon',               // 在庫保管手数料
  systemUsageFee: 'rakuten',            // システム利用料
  safetyFee: 'rakuten',                 // 安全性利用料
  // 決済手数料: 楽天=決済手数料 / Yahoo=決済サービス個別手数料
  paymentFee: ['rakuten', 'yahoo'],
  // ポイント原資: 楽天=絶対負担(税抜1%) / Yahoo=ストアポイント原資(税抜1%〜)
  pointsBaseCost: ['rakuten', 'yahoo'],
  // ポイント(店舗独自/キャンペーン): 楽天=倍率上乗せ分 / Yahoo=キャンペーン原資(1.5%)
  pointsCost: ['rakuten', 'yahoo'],
  transactionFee: 'shopify',            // 決済手数料(Shopify Payments等)

  // --- 商品PL(productKpiColumns) で異なるキー ---
  salesFees: 'amazon',                  // 販売手数料(商品PL)
  fbaShippingCost: 'amazon',            // FBA配送料(商品PL)
};

// キーからモール定義の配列を返す（全モール共通の項目は空配列）。
// 定義が文字列でも配列でも、常に配列で返す。
const getFeeMalls = (key) => {
  const value = feeMallByKey[key];
  if (value == null) return [];
  return (Array.isArray(value) ? value : [value]).map(_ => malls[_]).filter(_ => _);
};

// 後方互換: 単一のモール定義を返す（該当が複数ある場合は先頭）
const getFeeMall = (key) => getFeeMalls(key)[0];

exports.malls = malls;
exports.feeMallByKey = feeMallByKey;
exports.getFeeMall = getFeeMall;
exports.getFeeMalls = getFeeMalls;
